import { get, logWithAmplitude, throwHttpError } from './api';

import { GetAddOnResponse } from '../../types';

export async function getAddOns(amplitude_callsite: string) {
    const response = await fetch(`/api/add_ons`, get());

    if (!response.ok) {
        await throwHttpError('An error occurred while getting the add ons.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get All Add Ons for account');
    return await (response.json() as Promise<GetAddOnResponse[]>);
}

export async function getAddOn(
    amplitude_callsite: string,
    add_on_id: string
) {
    const response = await fetch(`/api/add_ons/${add_on_id}`, get());

    if (!response.ok) {
        await throwHttpError('An error occurred while getting the add on.', response);
    }

    logWithAmplitude(amplitude_callsite, 'Get Add On', {
        add_on_id
    });

    const normalizedResponse = await response.json() as GetAddOnResponse;

    return normalizedResponse;
}